import type { ConfigProviderProps } from 'antd';

const cssVar = (varName: string) => {
  const styles = getComputedStyle(document.documentElement);
  return styles.getPropertyValue(varName);
};

const antConfig: () => ConfigProviderProps = () => ({
  theme: {
    token: {
      fontFamily: 'Inter, sans-serif',
      colorPrimary: cssVar('--color-primary'),
    },
  },
});

export default antConfig;
